import React, {PureComponent} from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myAccountConfirmPasswordSelector from 'redux/selectors/my_account/my_account_confirm_password_selector'
import myAccountActions from 'redux/actions/myAccountActions'
import Modalizer from 'components/modalizer/modalizer'
import { localize } from 'helpers/translator'
import { MainButton } from 'components/button'
import TextInputForm from 'components/input/text/text_input_form'
import { Field, reduxForm, SubmissionError } from 'redux-form'

import styles from './my_account_confirm_password_form.scss'

const validate = values => {
	const errors = {}
	if (!values.password) {
		errors.password = localize('global_form_passwordIsRequired')
	}
	return errors
}

class MyAccountConfirmPassword extends PureComponent {

	constructor() {
		super()
		this.getFieldMessage = this.getFieldMessage.bind(this)
		this.getFieldStatus = this.getFieldStatus.bind(this)
		this.formSubmitHandler = this.formSubmitHandler.bind(this)
	}

	getFieldMessage(field) {
		return field.error
	}

	getFieldStatus(field, name) {
		if (field.touched && (field.invalid || field.value === '') && !field.active && field.visited) {
			return 'error'
		} else if (Object.keys(this.props.personalInfoErrors).includes(name)) {
			return 'error'
		} else if (field.value !== '' && !field.invalid && !field.active && field.visited
				&& [ 'password'].includes(name)) {
			return 'success'
		} else {
			return ''
		}
	}

	async formSubmitHandler(values) {
		try {
			await new Promise((resolve, reject) => {
				this.props.actions.savePersonalInfo(values, resolve, reject)
			})
			this.closePasswordForm()
		} catch (err) {
			if (!err.password) {
				this.closePasswordForm()
			}
			throw new SubmissionError({ ...err })
		}
	}

	canSendForm = () => !this.props.pristine && this.props.valid

	closePasswordForm = () => {
		this.props.actions.closePasswordForm()
		this.props.change('password', '')
	}

	render() {
		return (
			<Modalizer closeAction={this.closePasswordForm} boxed={false} >
				<div styleName="wrapper">
					<header styleName='header'>
						<h1 styleName='header-title'>{localize('my_account_confirm_password_title')}</h1>
						<p styleName='header-subtitle'>{localize('my_account_confirm_password_subtitle')}</p>
					</header>
					<section styleName='content'>
						<form id='profilePersonalForm' onSubmit={this.props.handleSubmit(this.formSubmitHandler)}>
							<label styleName='content-text'>{localize('my_account_confirm_password_input_title')}</label>
							<div styleName='content-input'>
								<Field
									name="password"
									component={TextInputForm}
									placeholder={localize('my_account_form_change_password_placeholder')}
									type="password"
									props={{
										getMessage: this.getFieldMessage,
										fieldStatus: this.getFieldStatus,
										tabIndex: 1,
										icons: {active: true},
									}}
								/>
							</div>
							<div styleName='content-button'>
								<div styleName='button-wrapper'>
									<MainButton
										tabIndex={2}
										disabled={!this.canSendForm()}
										type='submit'>
										{localize('my_account_confirm_password_button')}
									</MainButton>
								</div>
							</div>
						</form>
					</section>
				</div>
			</Modalizer>
		)
	}
}

function mapStateToProps(state) {
	return myAccountConfirmPasswordSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		savePersonalInfo: myAccountActions.savePersonalInfo,
		closePasswordForm: myAccountActions.closePasswordForm,
	}, dispatch)
}

MyAccountConfirmPassword = connect(
	mapStateToProps,
	mapDispatchToProps
)(CSSModules(MyAccountConfirmPassword, styles, {allowMultiple: true}))

export default reduxForm({
	form: 'ProfilePersonalForm',
	fields: ['password'],
	//enableReinitialize: true,
	destroyOnUnmount: false,
	validate,
})(MyAccountConfirmPassword)
